<template>
  <BasicText
    size="body-m"
    color="secondary-900"
  >
    Retrouvez ci-dessous l’ensemble des comptes auxquels vous êtes rattaché.
  </BasicText>
  <BasicPagination
    :current-page
    :nb-pages
    :nb-pages-max
    :nb-results="rattachements?.length ?? 0"
    @change="(v) => (currentPage = v)"
  />
  <div class="rattachements--desktop">
    <div class="cardLayoutWrapper cardLayoutWrapper--header">
      <div class="elem elem--span-10"><span>Comptes</span></div>
      <div
        v-for="tp in DROPDOWN_PERMS"
        :key="tp.key"
        class="elem elem--span-5"
      >
        <span>{{ tp.label }}</span>
      </div>
      <div
        v-for="tg in PERM_TOGGLES"
        :key="tg.label"
        class="elem elem--center elem--span-2"
      >
        <span>{{ tg.label }}</span>
      </div>
    </div>

    <div
      v-for="vm in pageVMs"
      :key="vm.id"
      class="cardLayoutWrapper gridElemWrapper"
    >
      <div class="elem elem--span-10">
        <div class="card__top">
          <BasicIcon :name="vm.display.icon" />
          <div class="card__top__text">
            <BasicText>{{ vm.display.title }}</BasicText>
            <BasicText class="sous-titre">{{ vm.siretLabel }}</BasicText>
          </div>
        </div>
      </div>
      <BasicCellDropdown
        v-for="tp in DROPDOWN_PERMS"
        :key="tp.key"
        :items="niveauxPermission"
        :model-value="getNiveauPermission(vm.permissions, tp.key)"
        readonly
        force-value
      />
      <BasicCellActionIcon
        v-for="tg in PERM_TOGGLES"
        :key="tg.label"
        :icon-name="tg.icon"
        center
        isReadonly
        :deactivated="getNiveauPermission(vm.permissions, tg.label) !== 'Ecriture'"
        :hover-messages="tg.hoverMessages"
      />
    </div>
  </div>
  <div class="rattachements--mobile">
    <div
      class="card"
      v-for="vm in pageVMs"
      :key="vm.id"
    >
      <div class="card__top">
        <BasicIcon :name="vm.display.icon" />
        <div class="card__top__text">
          <span>{{ vm.display.title }}</span>
          <span class="sous-titre">{{ vm.siretLabel }}</span>
        </div>
      </div>
      <div class="card__section">
        <WrapperDropdown
          v-for="tp in DROPDOWN_PERMS"
          :key="tp.key"
          :items="niveauxPermission"
          :model-value="getNiveauPermission(vm.permissions, tp.key)"
          readonly
          force-value
        />
      </div>
      <div class="card__bottom">
        <div
          v-for="tg in PERM_TOGGLES"
          :key="tg.label"
          class="elem elem--readonly"
        >
          <span>{{ tg.label }} :</span>
          <BasicCellActionIcon
            :icon-name="tg.icon"
            center
            isReadonly
            :deactivated="getNiveauPermission(vm.permissions, tg.label) !== 'Ecriture'"
            :hover-messages="tg.hoverMessages"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { storeToRefs } from 'pinia'
  import { objectToDropdownItems } from '@/features/interface/shared/tools'
  import { useRattachementsStore } from './useRattachementsStore'
  import { NiveauPermissionLibelle, TypePermission } from '@/features/domaine/types/opco'
  import type { PermissionDTO } from '@/features/api/extranet/dto/shared/PermissionDTO'
  import { useRattachementsListState } from '../useRattachementsListState'

  const store = useRattachementsStore()
  const { rattachements } = storeToRefs(store)

  const { pageVMs, currentPage, nbPages, nbPagesMax, DROPDOWN_PERMS, PERM_TOGGLES } =
    useRattachementsListState(rattachements)

  const niveauxPermission = objectToDropdownItems(NiveauPermissionLibelle)

  const getNiveauPermission = (permissions: PermissionDTO[], typePermission: TypePermission) =>
    permissions.find((p) => p.type === typePermission)?.niveau ?? ''
</script>

<style lang="less">
  @import '../../index.less';
</style>

<style scoped lang="less">
  @import '../Rattachements.less';
</style>
